<template>
	<div class="calendar-main-wrapper">
		<el-calendar
			v-bind:value="value"
			v-on="inputListeners"
			:first-day-of-week="7"
			operations="prev-month,today,next-month"
			hide-header
			fixed-header
			ref="elCalendarRef"
		>
			<template slot="theadCell" slot-scope="{ value }">
				<span>{{ formatWeek(value) }}</span>
			</template>
			<template slot="dateCell" slot-scope="{ date, data }">
				<slot name="dateCell" :date="date" :data="data"></slot>
			</template>
		</el-calendar>
	</div>
</template>

<script>
import i18n, { EN } from '@/locales';

export default {
	computed: {
		inputListeners: function () {
			var vm = this;
			// 将所有的对象合并为一个新对象
			return Object.assign(
				{},
				// 从父级添加所有的监听器
				this.$listeners,
				// 添加自定义监听器，或覆写一些监听器的行为
				{
					// 确保组件配合 v-model 的工作
					input: function (val) {
						vm.$emit('update:value', val);
					}
				}
			);
		}
	}
};
</script>

<script setup>
import { ref, defineExpose, getCurrentInstance } from 'vue';
const { proxy } = getCurrentInstance();

defineProps({
	value: {
		type: Date
	}
});

const elCalendarRef = ref();

const selectDate = type => {
	elCalendarRef.value && elCalendarRef.value.selectDate(type);
};

defineExpose({
	selectDate
});

const formatWeek = val => {
	const days = {
		'一': 'Mon',
		'二': 'Tue',
		'三': 'Wed',
		'四': 'Thu',
		'五': 'Fri',
		'六': 'Sat',
		'日': 'Sun'
	};
	if (i18n.locale === EN) {
		return days[val];
	}
	return `${proxy.$t('enterprise.datepicker.week')}${val.replace('日', '天')}`;
};
</script>

<style lang="less" scoped>
.calendar-main-wrapper {
	--calendar-background: #ffffff;
	--calendar-border-color: #e6e6e6;
	--calendar-thead-background: #f5f5f5;
	--calendar-cell-color: #000000;
	--calendar-cell-color--not-range: #b3b3b3;

	height: 100%;

	/deep/ .el-calendar {
		.el-calendar__thead_box {
			box-shadow: none;
			background: var(--calendar-thead-background);
		}

		.el-calendar__body {
			border: 1px solid var(--calendar-border-color);
			border-radius: 0;

			.el-calendar-table {
				.el-calendar-day {
					background: var(--calendar-background);
					cursor: default;

					span {
						font-family: inherit;
						padding: 2px;
						font-size: 12px;
						font-weight: 400;
						line-height: 16px; /* 133.333% */
					}
				}

				thead th {
					padding-top: 8px;
					padding-bottom: 8px;
					text-align: center;
					color: var(--calendar-cell-color);
					font-size: 12px;
					font-style: normal;
					font-weight: 400;
					line-height: 16px; /* 133.333% */
					border-color: var(--calendar-thead-background) !important;
				}

				td {
					color: var(--calendar-cell-color);
					border-color: var(--calendar-border-color) !important;

					&.is-selected {
						color: inherit;
					}
				}
			}
		}

		.el-calendar-table {
			&:not(.is-range) {
				td.prev,
				td.next {
					color: var(--calendar-cell-color--not-range);
				}
			}

			td {
				border-color: var(--calendar-border-color) !important;
			}
		}
	}
}
</style>
